
class GlobalCatch{

    _globalCatcher = (e:any)=>{};

    setGlobalCatch(catcher:(e:any)=>void){
        this._globalCatcher = catcher;
    }

    catch(action:Function){
        // console.log('GlobalCatch.catch a')
        return (...args:any[])=> action(...args).catch((err:any)=>{
            // console.log('GlobalCatch.catch', err)
            this._globalCatcher && this._globalCatcher(err);
            throw err;
        });
    }

}


export const globalCatch = new GlobalCatch();
